module.exports = __webpack_public_path__ + "static/img/LACHLAN-CARMICHAEL.20551a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LACHLAN-CARMICHAEL.jpg
// module id = GCdd
// module chunks = 0